import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearFilter } from "../redux/filters/actions";
const BlogHeader = () => {
    const filters = useSelector( (state) => state.filters );
    const dispatch = useDispatch();
    const {search, category, author_name} = filters;

    const buttonHandler = () => {
        dispatch(clearFilter());
    }

    return (
        <div class="text-center">
            <h2
                class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
            >
                ALL BLOGS ARE HERE
            </h2>
            <p
                class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4"
            >
                Lorem ipsum dolor sit amet consectetur, adipisicing
                elit. Ipsa libero labore natus atque, ducimus sed.
            </p>
            <div className="flex">
                
                <div>
                    {search.length > 0 || category.length > 0 || author_name.length > 0 ? <button class="bg-red-200 hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded" onClick={() => buttonHandler()}>
  Clear Filter
</button> : ''}
                </div>
            </div>
        </div>
    );
}

export default BlogHeader;